module.exports = __webpack_public_path__ + "static/media/SUNSET POINT SMALL AND BIG.7cb1952a.png";